import { defineComponent as _defineComponent } from 'vue'
import { StudioUser } from '@/modules/Studios/types'
import { ref } from 'vue'
import { useImage } from '@/shared/composables/image'
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import { getDateFormatted } from '@/services/date'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioMemberChip',
  props: {
    member: null,
    isExpandable: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { member: StudioUser, isExpandable: boolean };



const { getAvatar, getEventImg } = useImage()

const isExpanded = ref(!props.isExpandable)

const getRankText = (rank: number): string => {
  if (rank === 1) return '1st'
  if (rank === 2) return '2nd'
  if (rank === 3) return '3rd'
  if (rank === 4) return 'Top 4'
  if (rank === 5) return 'Top 5'
  return ''
}

const getRankIconClass = (rank: number): string => {
  if (rank === 1) return 'rank-icon icon-gold'
  if (rank === 2) return 'rank-icon icon-silver'
  if (rank === 3) return 'rank-icon icon-bronze'
  return 'rank-icon icon-compete'
}

const getEventDate = (date: string): string => {
  return getDateFormatted(new Date(date))
}

return { __sfc: true,props, getAvatar, getEventImg, isExpanded, getRankText, getRankIconClass, getEventDate, mdiChevronDown, mdiChevronUp }
}

})